import React, { useEffect, useState } from "react";
import { BarChart } from '@mui/x-charts/BarChart';
import { fetchUsageHistory } from '../../resources/AnalyticReportResource';

export default function HistoryUsage() {
  const [dataUsageHistory, setDataUsageHistory] = useState(null);
  const [filter, setFilter] = useState("this_month");
  const [dataFilter] = useState([
    {
      id: 1,
      code: "this_month",
      name: "This Month"
    },
    {
      id: 2,
      code: "last_three_month",
      name: "Last Three Month"
    },
    {
      id: 3,
      code: "last_year",
      name: "Last Year"
    },
  ]);
  const [partData] = useState([]);
  const [xLabels] = useState([]);

  const fetchDataUsageHistory = () => {
    fetchUsageHistory(filter)
      .then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].used !== null) {
            partData.push(res.data[i].used);
          } else {
            partData.push(0);
          }
          if (res.data[i].name !== null) {
            xLabels.push(res.data[i].name);
          } else {
            xLabels.push("-");
          }
        }

        setTimeout(() => {
          setDataUsageHistory(res.data);
        }, 200);

      })
      .catch((err) => {
        setDataUsageHistory([]);
      });
  };

  useEffect(() => {
    fetchDataUsageHistory();
    // eslint-disable-next-line
  }, []);

  const onChangeHandler = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("code");
    setFilter(option);

    fetchDataUsageHistory();
  };

  return (
    <div className="col-12 col-lg-5">
      <div className="card radius-15 overflow-hidden">
        <div className="card-header border-bottom-0">
          <div className="d-flex align-items-baseline">
            <div className="col"><h5 className="mb-0">History Usage</h5></div>
            <div className="col-auto">
              <select className="form-select mb-3" aria-label="Default select example"
                value={filter}
                onChange={onChangeHandler}>
                {
                  dataFilter.map((data) => {
                    return (<option id={data.code}
                      name={data.name}
                      key={data.code}
                      value={data.code}>{data.name}</option>);
                  })
                }
              </select>
            </div>
          </div>
        </div>
        <div className="card-body">
          {!dataUsageHistory ? <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '260px'
          }}>
            <div className="spinner-border text-primary" role="status"> <span className="visually-hidden">Loading...</span>
            </div>
          </div> : partData.length === 0 && xLabels.length === 0 ? <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '260px'
          }}>
            <div><span>Data is Empty</span></div>
          </div> : <BarChart
            width={450}
            height={300}
            series={[
              { data: partData, label: 'part', id: 'partId' },
            ]}
            xAxis={[{ data: xLabels, scaleType: 'band' }]}
            colors={['#962DFF']}
          />}
        </div>
      </div>

    </div>
  );
}